<template>
  <v-container>
    <!-- Instructions -->
    <v-row>
      <v-col cols="12">
        <v-card elevation="0" outlined>
          <v-card-title class="font-regular">Instructions</v-card-title>
          <v-card-text>
            <p class="subtitle-1 ma-0">
              Ensure that you have an active account on our KOBE platform:
              <a
                href="https://app.getkobe.com"
              >https://app.getkobe.com</a> with all your updated details.
            </p>
            <p class="subtitle-2 ma-0">Reminder:</p>
            <ul>
              <li>Both client and influencer will be mutually rated after each campaign and all scores will be kept confidential.</li>
              <li>Submitting of drafts and payments will be done seamlessly via our Kobe platform (your payout will be credited to your bank account once your post goes live and statistics uploaded on our platform)</li>
              <li>Do not live your post until you have received clearance from us, you will be notified through our platform and your email.</li>
              <li>For any appointment-based campaign, failure to turn up or cancellation will result in automatic removal of participation and penalty from the campaign.</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Instructions -->
    <!-- Campaign view -->
    <v-row>
      <v-col cols="12">
        <v-card elevation="0" outlined>
          <v-card-title class="font-regular">Campaign summary</v-card-title>
          <v-card-text>
            <v-row>
              <!-- Actions -->
              <v-col cols="12" md="6" sm="12" lg="6" align="left" justify="center">
                <p class="headline font-regular font-weight-bold ml-2">{{brief.campaignName}}</p>
                <div v-if="status === statusINVITED">
                  <v-btn class="ma-2 white--text" tile @click="doAction('interested')" color="success">
                    <v-icon left>mdi-check</v-icon>Interested
                  </v-btn>
                  <v-btn class="ma-2 white--text" @click="doReject('not_interested')" tile color="red">
                    <v-icon left>mdi-cancel</v-icon>Not Interested
                  </v-btn>
                  <v-btn class="ma-2" @click="doAction('inquiry')" tile color="info">
                    <v-icon left>mdi-help</v-icon>Inquiry
                  </v-btn>
                </div>
                <div v-if="status === statusINQUIRY">
                  <v-btn class="ma-2 white--text" tile @click="doAction('interested')" color="success">
                    <v-icon left>mdi-check</v-icon>Interested
                  </v-btn>
                  <v-btn class="ma-2 white--text" @click="doReject('not_interested')" tile color="red">
                    <v-icon left>mdi-cancel</v-icon>Not Interested
                  </v-btn>
                   <v-chip
                    class="ma-2"
                    color="info"
                    text-color="white"
                    >
                    <v-avatar left>
                      <v-icon>mdi-help-circle-outline </v-icon>
                    </v-avatar>You have asked the question about this invitation.
                  </v-chip>
                </div>
                <div v-if="status === statusINTERESTED">
                  <v-chip
                    class="ma-2"
                    color="success"
                    text-color="white"
                  >
                  <v-avatar left>
                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                  </v-avatar>You are interested in this campaign
                  </v-chip>
                </div>
                <div v-if="status === statusNOTINTERESTED">
                  <v-chip
                    class="ma-2"
                    color="red"
                    text-color="white"
                  >
                    <v-avatar left>
                      <v-icon>mdi-close-circle</v-icon>
                    </v-avatar>You have not interested in this invitation.
                  </v-chip>
                  <div>
                    <h4>Reasons of rejection</h4>
                    <ul v-if="rejectReasons">
                      <li v-if="rejectReasons.campaign_proposed">{{rejectReasons.campaign_proposed}}</li>
                      <li v-if="rejectReasons.campaign_timeline">{{rejectReasons.campaign_timeline}}</li>
                      <li v-if="rejectReasons.payout_issue">{{rejectReasons.payout_issue}}</li>
                      <li v-if="rejectReasons.competitor">{{rejectReasons.competitor}}</li>
                      <li v-if="rejectReasons.not_associate">{{rejectReasons.not_associate}}</li>
                      <li v-if="rejectReasons.others">{{rejectReasons.others}}</li>
                    </ul>
                  </div>
                </div>
                <div v-if="status === statusACCEPTED">
                  <div>
                    <v-chip
                      class="ma-2"
                      color="success"
                      text-color="white"
                      :small="$vuetify.breakpoint.mobile"
                    >
                    <v-avatar left>
                      <v-icon>mdi-check</v-icon>
                    </v-avatar>You are interested in this campaign
                    </v-chip>
                  </div>
                  <div>
                    <v-chip
                      class="ma-2"
                      color="success"
                      text-color="white"
                      :small="$vuetify.breakpoint.mobile"
                    >
                      <v-avatar left>
                        <v-icon>mdi-check</v-icon>
                      </v-avatar>You have been accepted for this campaign.
                    </v-chip>
                  </div>
                  <div v-if="(isAgree === 0 || isAgree === undefined)">
                    <p style="font-size:13px;font-weight:500;margin:20px 10px 0 10px;" v-if="briefDetailsHTML">
                    Review invoice and terms here.
                    </p>
                    <v-btn class="ma-2" tile  color="secondary" @click="showAgreement" v-if="briefDetailsHTML">
                        <v-icon left>mdi-check</v-icon>Invoice and Contract
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-chip v-if="isAgree"
                      class="ma-2"
                      color="success"
                      text-color="white"
                      :small="$vuetify.breakpoint.mobile"
                    >
                      <v-avatar left>
                        <v-icon>mdi-check</v-icon>
                      </v-avatar>You have agreed to the terms and conditions.
                    </v-chip>
                    <div v-else >
                      <v-chip
                        class="ma-2"
                        color="red"
                        text-color="white"
                        :small="$vuetify.breakpoint.mobile"
                      >
                        <v-avatar left>
                          <v-icon>mdi-cancel</v-icon>
                        </v-avatar>
                        You do not agree to the terms and conditions.
                      </v-chip>
                      <v-btn small rounded color="secondary" @click="showAgreement">Change your mind?</v-btn>
                      <div style="font-size:13px;font-weight:500;margin-left:15px;" >A Kobe representative will be in touch.</div>
                    </div>
                  </div>
                </div>
                <div v-if="status === statusNOTACCEPTED">
                  <v-chip
                    class="ma-2"
                    color="red"
                    text-color="white"
                  >
                    <v-avatar left>
                      <v-icon>mdi-close-circle</v-icon>
                    </v-avatar>You have been not accepted for this campaign.
                  </v-chip>
                </div>
              </v-col>
              <!-- Actions -->
              <!-- Deliverables -->
              <v-col cols="12" md="6" sm="12" lg="6">
                <p class="headline font-regular">
                  Payout:
                  <span class="success--text bold headline" v-if="GST">{{formatPayout(payout + (payout * 0.08))}}</span>
                  <span class="success--text bold headline" v-else>{{formatPayout(payout)}}</span>
                </p>
                <p class="title ma-0 font-regular">Deliverables</p>
                <ul v-if="deliverables">
                  <li v-if="deliverables.no_of_posts">
                    <strong>{{deliverables.no_of_posts}}</strong> x Instagram Post
                  </li>
                  <li v-if="deliverables.no_of_stories">
                    <strong>{{deliverables.no_of_stories}}</strong> x Instagram Stories
                  </li>
                  <li v-if="deliverables.no_of_carousels">
                    <strong>{{deliverables.no_of_carousels}}</strong> x Instagram Carousel
                  </li>
                  <li v-if="deliverables.no_of_video">
                    <strong>{{deliverables.no_of_video}}</strong> x Instagram Video
                  </li>
                  <li v-if="deliverables.no_of_igTv">
                    <strong>{{deliverables.no_of_igTv}}</strong> x Instagram TV
                  </li>
                </ul>
              </v-col>
              <!-- Deliverables -->
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Campaign view -->
    <!-- Influencer Questions & Answers -->
    <v-row v-if="status === statusINQUIRY" >
        <v-col col="12">
          <v-card elevation="0" outlined>
          <v-card-title class="font-regular" >
              Recent Questions
          </v-card-title>
            <v-card-text>
            <v-btn class="ma-2" tile color="info" @click="inquiryBox">
                <v-icon left>mdi-plus</v-icon>New Question
            </v-btn>
            <hr v-show="showUnderLine || this.loadAllQuestoins.length > 0"/>
              <QandA :Questions="loadAllQuestoins" :campaignID="this.$route.params.campaignID" :influencerID="this.influencer" :TriggerEmail="true" :key="QandAComponentKey" :pairedID="pairingID" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    <!-- END Influencer Questions & Answers -->

    <v-row >
      <!-- Brief Details -->
        <v-col col="12" v-if="(status === statusINTERESTED || status === statusACCEPTED || status === statusNOTACCEPTED) && (briefDetailsHTML && briefDetailsHTML !== {})" >
          <v-card elevation="0" outlined>
          <v-card-title class="font-regular" >
              Brief Details
              <hr/>
          </v-card-title>
          <v-card-text>
            <div v-html="this.briefDetailsHTML" ></div>
          </v-card-text>
          <!-- <v-card-text v-else>
            <div style="font-size:13px;font-weight:600px;text-align:center;width:100%;">
              <p>
                Your brief details are not ready yet.<br/>
                We'll let you know via email once it is ready.<br/><br/>
                Thank you.
              </p>
            </div>
          </v-card-text> -->
          </v-card>
        </v-col>
      <!-- Brief Details END -->
      <v-col v-show="brief.campaignBackground">
        <v-card elevation="0" outlined>
          <v-card-title>
            Campaign Background
          </v-card-title>
          <v-card-text>
            <p style="white-space: pre-wrap;">{{brief.campaignBackground}}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- Content angle -->
      <!-- <v-col v-else cols="12" align="center">
        <v-card tile shaped outlined>
          <v-card-title class="font-regular">Content Angle</v-card-title>
          <v-card-text align="left">
            <v-card tile outlined class="mb-5" v-for="(angle, index) of brief.angles" :key="index">
              <v-card-title>{{angle.option_name}}</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <p class="caption ma-0">Required action</p>
                    <p class="subtitle-2 ma-0">{{angle.required_action}}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <p class="caption ma-0">Image angle</p>
                    <p class="subtitle-2 ma-0">{{angle.image_angle}}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <p class="caption ma-0">Content angle</p>
                    <p class="subtitle-2 ma-0">{{angle.content_angle}}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <p class="caption ma-0">Image inspiration</p>
                    <v-row v-if="angle.sample_images && Array.isArray(angle.sample_images)">
                      <v-col cols="3" v-for="image of angle.sample_images" v-bind:key="image">
                        <v-img
                          :src="constructImage(image)"
                          :lazy-src="`https://picsum.photos/10/6?image=3`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col> -->
      <!-- Content angle END -->
    </v-row>
    <!-- Content angle -->
    <!-- Influencer Contract modal comment for now -->
    <!-- <influencer-contract-modal :dialog="showContractModal" :close="closeInfluencerContractModal" :contract="influencerContract" :action="pairingAction" /> -->
    <reject-modal :dialog="showRejectModal" :close="closeRejectModal" :pairingID="pairingID" :updateStatus="updatStatus" />
    <influencer-contract-modal
    dialogTitle='Invoice and Contract'
    :dialog= 'showContractModal'
    :close= 'closeInfluencerContractModal'
    :contract= 'influencerContract'
    :didAgree = 'didAgree'
    :didNotAgree = 'didNotAgree'
    :showTerms = 'true'
    :showSendButton = 'false'
    :showSubmitButton = 'true'
    :showDeclineButton = 'true'
    :showOptions = 'true'
    :showCancelButton = 'false'
    :isAgreement= 'true'
    :briefDetailHTML='briefDetailsHTML' />
  </v-container>
</template>
<script>
import pairingAPIs from '../../Pairing/pairingAPIs';
// import campaignConfig from '../config';
import utils from '@/utils';
import RejectModal from './RejectModal.vue';
import QandA from './QandA.vue';
import { mapGetters } from 'vuex'
import InfluencerContractModal from '../CampaignInvite/InfluencerContractModal'
import BlocksToHtml from '../../../editor/generator/blocksToHtml'

export default {
  name: 'CampaignInviteDetail',
  data() {
    return {
      campaignID: '',
      defaultMsg: 'Could not load invitation',
      pairingID: null,
      brief: {},
      payout: 0,
      // amount: 0,
      status: null,
      deliverables: null,
      question: '',
      loadAllQuestoins: [],
      showRejectModal: false,
      rejectReasons: {},
      QandAComponentKey: 0,
      showUnderLine: false,
      briefDetailsHTML: '',
      showContractModal: false,
      influencerContract: {},
      isAgree: '',
      GST: ''
    };
  },
  components: {
    QandA,
    RejectModal,
    InfluencerContractModal
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    influencerID() {
      return this.$store.state.user.influencerID;
    },
    statusINVITED() {
      return this.pairingStatus.INVITED.value;
    },
    statusINTERESTED() {
      return this.pairingStatus.INTERESTED.value;
    },
    statusNOTINTERESTED() {
      return this.pairingStatus.NOT_INTERESTED.value;
    },
    statusACCEPTED() {
      return this.pairingStatus.ACCEPTED.value;
    },
    statusNOTACCEPTED() {
      return this.pairingStatus.NOT_ACCEPTED.value;
    },
    statusINQUIRY() {
      return this.pairingStatus.INQUIRY.value;
    },
    influencer() {
      return this.$store.state.user.influencerID;
    },
    userID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    }
  },
  created() {
    this.campaignID = this.$route.params.campaignID;
    if (!this.campaignID || !this.influencer) {
      this.$swal({
        type: 'error',
        text: 'Invalid campaign id'
      });
      return;
    }
    this.viewInvitation(this.campaignID, this.influencer)
    this.loadQuestions()
    // console.log('Store pairing status', this.statusINQUIRY)
  },
  methods: {
    diplayAgreement() {
      if (this.influencerContract.agreement !== undefined && this.influencerContract.agreement.isAgree !== undefined) {
        this.isAgree = this.influencerContract.agreement.isAgree
      } else this.isAgree = 0
    },
    forceRenderQandAComponent() {
      this.QandAComponentKey += 1
      // console.log('Force Render', this.QandAComponentKey)
    },
    constructImage(imageName) {
      return utils.func.constructImageURL(imageName);
    },
    async viewInvitation(campaign, influencer) {
      try {
        const invitation = await pairingAPIs.getInvitation(campaign, influencer);

        // console.log('Invitation Data', invitation)
        this.brief = invitation.brief;
        this.pairingID = invitation.id;
        this.payout = invitation.payout;
        this.amount = invitation.amount;
        this.deliverables = invitation.deliverables;
        this.status = invitation.status;
        this.rejectReasons = (invitation.reject_reasons ? invitation.reject_reasons : null);
        this.GST = invitation.GST;

        if (invitation.brief_details) {
          let blocksTohtml = new BlocksToHtml(invitation.brief_details.content)
          this.briefDetailsHTML = blocksTohtml.generate()
          // console.log('Brief Detail HTML', this.briefDetailsHTML)
          let invitationObject = Object.assign({}, invitation)
          invitationObject.campaignID = this.$route.params.campaignID
          this.influencerContract = invitationObject
        }
        this.diplayAgreement();
      } catch (error) {
        const message = error ? error.message || this.defaultMsg : this.defaultMsg;
        this.$swal({
          type: 'error',
          text: message
        });
      }
    },

    doReject() {
      this.showRejectModal = true
    },
    closeRejectModal() {
      this.showRejectModal = false
    },

    async doAction(action) {
      // if (action !== 'not_interested' && action !== 'interested' && action !== 'inquiry') {
      //   return;
      // }
      let confirmed
      switch (action) {
        case 'interested':
          confirmed = await this.confirmationBox()
          break;
        case 'not_interested':
          confirmed = await this.rejectionBox()
          break;
        case 'inquiry':
          confirmed = await this.inquiryBox()
          break;
        default: break;
      }

      // const confirmed = action === 'not_interested' ? await this.rejectionBox() : (action === 'interested' ? await this.confirmationBox() : await this.inquiryBox())
      if (!confirmed) return;
      // console.log('confirm action', action);
      this.updatStatus(action)
    },

    async updatStatus(action) {
      await pairingAPIs.doAction(this.pairingID, action);
      // this.status = action === 'not_interested' ? this.statusNOTINTERESTED : (action === 'interested' ? this.statusINTERESTED : this.statusINQUIRY);

      switch (action) {
        case 'interested':
          this.status = this.statusINTERESTED
          break;
        case 'not_interested':
          this.status = this.statusNOTINTERESTED
          break;
        case 'inquiry':
          this.status = this.statusINQUIRY
          break;
        default: break;
      }

      this.viewInvitation(this.campaignID, this.influencer);
      this.influencerStatusUpdateEmailToCo(action)
    },
    /**
     * Sending email to CO's when influerence interested/not intersted/inquiry
     */
    async influencerStatusUpdateEmailToCo(status) {
      let params = {
        campaignID: this.$route.params.campaignID,
        influencer: this.$store.state.user.firstName + ' ' + this.$store.state.user.lastName,
        url: `${window.location.protocol}//${window.location.host}/campaigns/invited-influencer`,
        template: 'influencer_status_update_campaign'
      }
      if (status === 'interested') {
      // console.log('Email params', params)
        params.subject = `We have a response from ${params.influencer} from ${this.brief.campaignName} campaign`
        params.message = `has indicated that they are interested in ${this.brief.campaignName} campaign. `
      } else if (status === 'not_interested') {
        params.subject = `We have a response from ${params.influencer} from ${this.brief.campaignName} campaign`
        params.message = `has indicated that they are not interested in ${this.brief.campaignName} campaign. Please get in touch accordingly.`
      }

      await pairingAPIs.sendInfluencerStatusUpdateEmailToCO(params)
    },

    async saveQuestion() {
       /**
       * Save Question into DB
       */
      let QuestionsData = {
        'campaignID': this.$route.params.campaignID,
        'userID': this.userID,
        'influencerID': this.influencer,
        'question': this.question,
        'answers': []
      }
      await pairingAPIs.postQuestions(QuestionsData).then(() => {
        this.forceRenderQandAComponent()
        this.loadQuestions()
        this.triggerEamilWithQuestion(this.question)
        this.showUnderLine = true
      })
    },
    async triggerEamilWithQuestion(question) {
      let params = {
        campaignID: this.$route.params.campaignID,
        influencer: this.$store.state.user.firstName + ' ' + this.$store.state.user.lastName,
        url: `${window.location.protocol}//${window.location.host}/influencers/pairing/${this.pairingID}`,
        type: 'question',
        question
      }
      // console.log('Email params', params)
      await pairingAPIs.triggerEmailToCO(params)
    },
    async loadQuestions() {
      let campaignID = this.$route.params.campaignID
      let allQuestions = await pairingAPIs.getQuestions(campaignID, this.influencer)
      let questionArray = [];
      for (let questionObj of allQuestions) {
        questionArray.push(questionObj)
      }
      this.loadAllQuestoins = questionArray;
    },
    async confirmationBox() {
      const result = await this.$swal({
        title: 'Thank you!',
        // text: 'You are about to accept the campaign invitation. Are you sure?',
        html: `<p style='text-align:left;font-weight:400;'>We have received your indication of interest, let us work on the confirmation with client.</p>
               <p style='text-align:left;font-weight:400;'>You will be receiving an official campaign brief and invoice upon confirmation here and via email.</p>`,
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok'
      });
      return result.value;
    },
    async rejectionBox() {
      const result = await this.$swal({
        title: 'Please confirm',
        text: 'Are you sure to reject this opportunity?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Reject it!'
      });
      return result.value;
    },
    async inquiryBox() {
      const result = await this.$swal({
        title: 'Ask your question',
        text: 'What do you want to know about this campaign?',
        input: 'textarea',
        inputLabel: 'Question',
        inputPlaceholder: 'Type your question here...',
        inputAttributes: {
          'aria-label': 'Type your question here'
        },
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        inputValidator: (value) => {
          if (!value) {
            return 'You need to write something!'
          } else {
            this.question = value
            this.saveQuestion()
          }
        }
      });
      return result.value;
    },
    closeInfluencerContractModal() {
      this.showContractModal = false;
    },
    showAgreement() {
      this.showContractModal = true;
    },
    didAgree() {
      this.isAgree = true;
      this.showContractModal = false;
    },
    didNotAgree() {
      this.isAgree = false;
      this.showContractModal = false;
    },
    formatPayout(n) {
      if (n.toString().indexOf('-') !== -1) {
        let str = n.toString().split('-')
        return utils.func.formatCurrency(parseFloat(str[0])) + ' - ' + str[1]
      } else {
        return utils.func.formatCurrency(parseFloat(n))
      }
    }
  }
};
</script>
<style scope>
ul > li {
  list-style: circle;
}
</style>



// WEBPACK FOOTER //
// CampaignInviteDetail.vue?6dd16206